import { createReducer, on } from "@ngrx/store";
import { userAll, userCreate, userDelete, userList, userUpdate } from "./user.action";

export const INIT_STATE = {
  items: [],
};

export const reducerUser = createReducer(
  INIT_STATE,
  on(userAll, (state, { items }) => {
    return {
      ...state,
      allItems: [...items],
    };
  }),
  on(userList, (state, { items }) => {
    return {
      ...state,
      items: [...items],
    };
  }),
  on(userCreate, (state, { item }) => {
    return {
      ...state,
      items: [...state.items, item],
    };
  }),
  on(userUpdate, (state, { item }) => {
    let index = state.items.findIndex((o) => o.id === item.id);

    const items = [...state.items];

    if (index > -1) {
      items[index] = item;
    }

    return {
      ...state,
      items: items,
    };
  }),
  on(userDelete, (state, { item }) => {
    let items = state.items.filter((o) => o.id !== item.id);

    return {
      ...state,
      items: items,
    };
  })
);
